import { visitorAtom } from "../../state";
import { createDerivedWritableAtom } from "../../../utils";

export const deadlineAtom = createDerivedWritableAtom(visitorAtom, "deadline");
export const sessionConversationSidAtom = createDerivedWritableAtom(
  visitorAtom,
  "sessionConversationSid",
);
